const formatTelephone = (telephone: string) => telephone
    .replace(/\D/g, '')
    .replace(/(\d*)(\d{3})(\d{3})(\d{4})$/, (s, a, b, c, d) => `+${a} (${b}) ${c}-${d}`)
    .replace(/\+(1\b|\s)\s*/, '')

export default formatTelephone;